import React from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Button } from 'antd';
import { useMutation } from "@apollo/client";
import { ROLE_CREATE } from "graphql/mutation/role-gql";
import UserGroupConst from '../../usergroup-const';
import FormItems from "../fields";
import { errorNotification, successNotification } from "components/request-result";
import { Localize } from "components/service";


const basePath = UserGroupConst.basePath;

const UserGroupCreateForm = ({ canManageUserGroups = false }) => {

    let history = useHistory();

    const [ form ] = Form.useForm();

    const [ roleCreateRequest, { loading } ] = useMutation(ROLE_CREATE,
        {
            update(cache, { data }) {

                const {
                    roleCreate: {
                        label,
                        message
                    }
                } = data;

                successNotification({
                    title: label,
                    description: message
                });

                if (data?.roleCreate?.role.id)
                {

                    history.push(`${ basePath }`);

                }

            },
            onError(error) {
                errorNotification(error);
            }
        }

    );

    return (
        <>
            <Form
                key="create-user-group"
                layout="vertical"
                className="usergroup-form"
                form={ form }
                onFinish={ (values) => {
                    if (!canManageUserGroups) return;

                    roleCreateRequest({
                        variables: {
                            input: { ...values }
                        }
                    }).catch((error) => {
                        errorNotification(error);
                    });
                } }
            >
                <Form.Item
                    name="label"
                    label={ <Localize>FORMS.Input_Label_GroupName</Localize> }
                    rules={ [
                        { required: true, message: <Localize>FORM_RULES.Required_GroupName</Localize> }
                    ] }
                >
                    <Input
                        name="label"
                        disabled={ !canManageUserGroups }
                        placeholder={ Localize({ children: "FORMS.Input_Placeholder_GroupName" }).props.children }
                    />
                </Form.Item>

                <FormItems.ColorSelect disabled={ !canManageUserGroups } />

                <FormItems.PermissionCheckbox disabled={ !canManageUserGroups } />

                { canManageUserGroups && <div className="form-btn-holder">

                    <Button
                        className="btn-right"
                        loading={ loading }
                        disabled={ loading }
                        type="primary"
                        htmlType="submit"
                    >
                        <Localize>GROUP.Button_Text_Create</Localize>
                    </Button>

                </div> }

            </Form>
        </>
    );

};

export default UserGroupCreateForm;
